import cn from 'classnames';
import { RecommendationItem } from './RecommendationItem/RecommendationItem';
import styles from './RecommendationsList.module.scss';

export const RecommendationsList = ({
                                      items = [],
                                      hideHeading = false,
                                      listView,
                                      props
                                    }) => {
  return (
    <div {...props} className={cn(styles.listContainer)}>
      {!hideHeading && (
        <span className={cn(styles.listTitle, 'text-3xl font-fragment sm:mb-10 mb-20')}>
          More from BusinessClass.com
        </span>
      )}
      {!listView && <div className={cn(styles.itemBlock, items.length > 1 && 'lg:grid lg:grid-cols-2 lg:gap-x-8')}>
        {!!items.length &&
          items.map((item, i) => {
            return <div key={item.title}
                        className={cn((items.length > 1 && i === items.length - 1) && styles.halfWidth, styles.item)}>
              <RecommendationItem key={item.title} item={item} />
            </div>;
          })}
      </div>}
      {listView && <div className={cn(styles.itemBlock, items.length > 1 && 'flex flex-col items-center')}>
        {!!items.length &&
          items.map((item) => {
            return <div key={item.title}
                        className={cn(styles.item)}>
              <RecommendationItem key={item.title} item={item} />
            </div>;
          })}
      </div>}
    </div>
  );
};
export default RecommendationsList;
